import { EventEmitter, Injectable, Output } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AttributeImportViewService {

  
  selectedCamposImportacionList: BehaviorSubject<any> = new BehaviorSubject([]);  
  @Output() isSaveExcelImportTemplate = new EventEmitter<any>();


  
}
